export const HYDRATION_STANDARD_SCROLL_BUFFER = 50;
export const HYDRATION_EARLY_DELAY = 5;
export const HYDRATION_STANDARD_DELAY = 1000;
export const SKIP_AKAMAI_RESIZE = ['Newspaper'];
export const SSR_ALLOWED_COMPONENTS = ['Newspaper'];
